/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MilkAndDerivativesViewerAliases {
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  MEDICATION_OR_SOLUTION_DETAILS_CARD = 'medication-or-solution-details-card',
  MILK_AND_DERIVATIVES_CONTENT_PANEL = 'milk-and-derivatives-content-panel',
  MILK_AND_DERIVATIVES_EXECUTE_BUTTON = 'milk-and-derivatives-execute-button',
  MILK_AND_DERIVATIVES_PANEL_BUTTON = 'milk-and-derivatives-panel-button',
  MILK_AND_DERIVATIVES_VIEWER_CONTEXTUAL_BAR = 'milk-and-derivatives-viewer-contextual-bar',
  MILK_AND_DERIVATIVES_VIEWER_DECK = 'milk-and-derivatives-viewer-deck',
  MILK_AND_DERIVATIVES_VIEWER_LAYOUT = 'milk-and-derivatives-viewer-layout',
  MILK_AND_DEVIVATIVES_GLOBAL_ACTIONS = 'milk-and-devivatives-global-actions',
  PANEL_HEADER = 'panel-header',
}
export { MilkAndDerivativesViewerAliases };
